import React from "react";

import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import { toast } from "react-toastify";

import { postRightworkAPI } from "../../requests/utilities/requests";
import { API_start_store_actuals_backfill } from "../../../../constants";

function RefreshActualsButton(props) {
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  // Actuals are sourced from the POS — nothing to refresh without one.
  if (!props.pos_provider) {
    return null;
  }

  const handleRefreshActuals = async () => {
    if (
      props.monthlyView ||
      isRefreshing ||
      !props.store_id ||
      !props.start_date ||
      !props.end_date
    ) {
      return;
    }

    // Close the Tools menu — progress is surfaced via the loading toast.
    props.onMenuItemClick?.();

    setIsRefreshing(true);
    toast.loading("Refreshing actuals for the week — this can take a couple of minutes...", { autoClose: false });
    try {
      await postRightworkAPI(API_start_store_actuals_backfill, {
        store_id: props.store_id,
        start_date: props.formatDate(props.start_date),
        end_date: props.formatDate(props.end_date),
      });
      await props.refreshActualsForDate?.();
      toast.dismiss();
      toast.success("Actuals refreshed for the week.", { autoClose: 4000 });
    } catch (error) {
      const message =
        error?.response?.data?.system?.message ||
        "Unable to refresh actual labor data.";
      toast.dismiss();
      toast.error(message, { autoClose: 4000 });
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <MenuItem
      onClick={handleRefreshActuals}
      disabled={props.monthlyView || isRefreshing}
      sx={{ py: 1.25 }}
    >
      <ListItemIcon>
        {isRefreshing ? (
          <CircularProgress size={18} sx={{ color: "#6d28d9" }} />
        ) : (
          <RefreshIcon fontSize="small" />
        )}
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}>
        {isRefreshing ? "Refreshing actuals..." : "Refresh actuals"}
      </ListItemText>
    </MenuItem>
  );
}

export default RefreshActualsButton;
